import { G_VERSION } from './Const'
import { GetCoreImport } from '../themes/definitions'

const isSSR = () => {
  return typeof window === 'undefined' || !window.document
}
export class ThemeCoreItem {
  id: string
  defaultCore: string
  core: string
  fallbackCores?: Array<string>
  theme: string
  path: string
  cacheKey: string
  error: string

  loadstatus: string
  elem?: Element | HTMLStyleElement
  lastFallbackIndex?: number
  loadCallback?: (retval: number, msg?: string) => void

  constructor(core: string, theme: string, fallbackCores?: Array<string>) {
    this.core = core
    this.defaultCore = core
    this.theme = theme
    this.loadstatus = 'init'
    this.id = this.getLinkID()

    this.error = ''
    this.fallbackCores = fallbackCores
    this.lastFallbackIndex = 0
    this.cacheKey = ''
    this.updatePath()
  }

  async updatePath() {
    //this.path = `${this.distpath}/${this.theme}/${this.core}.css?ver=${G_VERSION}&cc=${this.cacheKey}`
  }

  getLinkID = () => {
    return `theme_${this.theme}_${this.core}`.replace(/[-.]/gi, '_')
  }

  logErr(msg: string) {
    if (!isSSR()) {
      if (document['DEBUG']) {
        console.log(
          `Error in ☢Core (${msg}) Item: ${this.core} Theme: ${this.theme} at ${this.path}`
        )
      }
    }
  }

  async append(fallbackCnt?: number) {
    if (!isSSR()) {
      await this.updatePath()
      let result = undefined

      const existingLink = document.querySelector(`link[href="${this.path}"]`)
      if (existingLink && existingLink.getAttribute('loadstatus') == 'loaded') {
        this.elem = existingLink
        return this
      }

      const self = this

      const module = await GetCoreImport(this.theme, this.core)

      //console.log('Load Test', this.theme, this.core, module)

      const style = document.createElement('style')
      style.setAttribute('themecore', 'style')
      style.setAttribute('id', this.getLinkID())
      //@ts-ignore
      style.innerHTML = module.default
      style.setAttribute('loadstatus', 'loaded')
      style.setAttribute('name', this.core)
      style.setAttribute('data-name', this.core)
      style.setAttribute('theme', this.theme)
      style.setAttribute('data-theme', this.theme)

      let nearest: Element | undefined = document.head.children[0]
      for (let i = 0; i < document.head.children.length; i++) {
        if (document.head.children[i].hasAttribute('component_css')) {
          nearest = document.head.children[i]
          break
        }
      }
      try {
        if (nearest) {
          document.head.insertBefore(style, nearest)
        } else {
          document.head.appendChild(style)
        }

        self.loadstatus = 'loaded'

        //console.log(`☢☢ Core Resolved ☢☢ (${this.core}) `, this)
      } catch (e) {
        if (document['DEBUG']) {
          console.log(`☢☢ Catch Error Core:(${this.core}) `, e, this)
        }

        if (
          this.fallbackCores?.length > 0 &&
          (!fallbackCnt || fallbackCnt <= this.fallbackCores?.length)
        ) {
          this.remove()
          const bkcore = this.fallbackCores[this.lastFallbackIndex]
          if (bkcore) {
            this.core = bkcore
            this.lastFallbackIndex = this.lastFallbackIndex + 1
            fallbackCnt = (fallbackCnt ?? 0) + 1

            result = await this.append(fallbackCnt)
            return result
          }
        }
        this.loadCallback?.(3, JSON.stringify(e))
        this.logErr(`Failed to load : ${this.elem?.id} ${JSON.stringify(e)}`)
      }

      return result
    }
  }

  async remove() {
    if (!isSSR()) {
      try {
        let existingCore = document.querySelector(
          `style[name="${this.core}"][theme="${this.theme}"]`
        )
        if (!existingCore) {
          existingCore = document.getElementById(this.getLinkID())
        }

        //console.log("To Removed core XX", item.path, existingCore,linkid, document.head.children)
        if (existingCore) {
          document.head.removeChild(existingCore)
        } else if (this.elem) {
          this.elem.remove()
        }
        this.loadstatus = 'removed'
        this.elem = undefined
        return this
      } catch (e) {
        this.loadstatus = 'failed'
        this.logErr(String(e))
        return this
      }
    }
  }
}
